import Controller from './Controller';
import type Report from '../checks/Report';
import { Combined_CreateObject } from '../commands/combined';
import { upperFirst } from 'lodash';
import type { ObjectProperties, Position, AutoEventsAndMethods } from '../commands/types';

/**
 * The default event/method names derived from an object type name. A subset of
 * `AutoEventsAndMethods` (the four generated names), surfaced to the UI form.
 */
interface DefaultNames {
  create_event_name: string;
  end_event_name: string;
  create_method_name: string;
  end_method_name: string;
}

/**
 * Controller to add a new object type
 */
export default class AddObjectController extends Controller {
  // Utility function to get the default event type and methods names for the
  // given object type name
  defaults(name: string): DefaultNames {
    return {
      create_event_name: `EVcr${upperFirst(name)}`,
      end_event_name: `EVend${upperFirst(name)}`,
      create_method_name: `MEcr${upperFirst(name)}`,
      end_method_name: `MEend${upperFirst(name)}`,
    };
  }

  // Expose all existing event type names
  get existingEventNames(): string[] {
    return this.modelVersion.content!.metamodel.eventNames;
  }

  /**
   * Add a new object type
   *
   * @param {Object} properties The properties for the object. See CCMC_Object.
   * @param {Object} position The position for the object. See createEDGNode.
   * @param {Object} methods_and_events Information about the methods and events
   * to be created. See CCMC_Object.
   */
  async addObject(
    properties: ObjectProperties,
    position: Position | undefined,
    methods_and_events: AutoEventsAndMethods
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_CreateObject(model, properties, position, methods_and_events);
      return checks;
    });
  }
}
